import { Controller } from "stimulus";
import Swal from 'sweetalert2';
import Popper from 'popper.js';
import { isEmpty } from 'lodash';
import ReschedulingAttendance from '../entrypoints/src/admin/controllers/attendance/rescheduling-attendance';
import { keyTracker } from '../entrypoints/src/admin/utilities/shortcuts';
import BootstrapNavTabs from '../entrypoints/src/admin/components/bootstrap_nav_bars';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import sweet_alert from '../entrypoints/src/admin/utilities/sweet_alert';

export default class extends Controller {
  connect() {
    if (document.querySelectorAll('.attendance-card').length == 0)
      return;

    if (!document.querySelector('input[id^="attendances_"]'))
      return;

    const navContainer = this.element.querySelector('.tr-nav');
    if (navContainer) {
      BootstrapNavTabs.mergeCustomFeatures(navContainer, { updateLinks: 'ul.navigation-dates li a' });
    }

    this.element.querySelectorAll('.student-actions[data-toggle="dropdown"]').forEach(($el) => {
      new Popper($el, $el.closest('.dropdown').querySelector('.dropdown-menu'), {
        modifiers: {
          preventOverflow: { enabled: false },
          hide: { enabled: false },
          placement: 'top-start'
        },
      });
    });

    document.querySelectorAll('a[data-submit-form], button[data-submit-form]').forEach(($el) => {
      $el.addEventListener('click', (ev) => {
        ev.preventDefault();
        let form = document.querySelector('form.tr-form[data-submit-form]'),
          action = form.getAttribute('action');

        form.setAttribute('action', `${action}${window.location.hash}`);
        form.submit();
      });
    });

    document.querySelectorAll('[data-submit-form-attributes]').forEach(($el) => {
      $el.addEventListener('click', (ev) => {
        ev.preventDefault();

        if(!$el.dataset.submitFormAttributes)
          return;

        Swal.fire({
          title: 'Atenção',
          html: $el.dataset.text,
          showClass: { backdrop: 'swal2-noanimation', popup: '', },
          hideClass: { popup: '' },
          customClass: {
            cancelButton: 'btn btn-gray-primary',
            confirmButton: 'btn btn-primary mr-3'
          },
          buttonsStyling: false,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, iniciar!'
        }).then(async (result) => {
          if (!result.value) return;

          let [name, value] = $el.dataset.submitFormAttributes.split('='),
            form = document.querySelector('#appointment-attendances-form');
          AjaxLoader.show();
          form.insertAdjacentHTML('afterBegin', `<input type="hidden" value="${value}" name="${name}" />`);
          form.submit();
        });
      })
    });

    this.formatParamsNames();
    this.handleTableEvents();
    this.handleObservationEvents();
    this.handleReschedulingEvents();
    this.handleButtonsActionsEvents();
    this.form = this.element.closest('form');
    this.scheduleBoardModal = document.querySelector('.schedule-board-modal');
    this.buttonSaveSelectedSchedule = !!this.scheduleBoardModal && this.scheduleBoardModal.querySelector('#save-selected-schedule');
    !!this.buttonSaveSelectedSchedule && this.buttonSaveSelectedSchedule.addEventListener('click', () => this.saveSelectedSchedule());
    this.rescheduling = new ReschedulingAttendance(this.element, this.scheduleBoardModal);
    this.handleSendMeetingUrl();
  }

  handleSendMeetingUrl() {
    if (!this.form)
      return;

    const $linkShareUrlMeeting = this.element.querySelector('#send-url-meeting'),
      $appointmentMeetingUrl = this.element.querySelector('#appointment_meeting_url');

    if (!$linkShareUrlMeeting || !$appointmentMeetingUrl)
      return;

    $linkShareUrlMeeting.addEventListener('click', (ev) => {
      ev.preventDefault();
      if ($appointmentMeetingUrl.value.trim() === '')
        return sweet_alert.fire({
          html: 'Nenhum link de reunião foi informado.',
          showCloseButton: true,
          showCancelButton: false
        });

      this.element.querySelector('#appointment_notify_meeting_url').checked = true;
      this.form.submit();
    });
  }

  formatParamsNames() {
    this.element.dataset.attendancesName = document.querySelector('input[id^="attendances_"]').name.match(/(appointment\[attendances_attributes\]\[.*?\])/)[0];
  }

  handleReschedulingEvents() {
    document.querySelectorAll('a[data-rescheduling]').forEach((link) => {
      link.addEventListener('click', this.onReschedulingClick.bind(this), false);
    });

    document.querySelectorAll('a[data-remove-rescheduling]').forEach((link) => {
      link.addEventListener('click', this.onRemoveReschedulingClick.bind(this, link), false);
    });
  }

  onRemoveReschedulingClick(link) {
    this.rescheduling.askToRemoveRescheduling(link.closest('.attendance-card').querySelector('.presences'));
  }

  handleButtonsActionsEvents() {
    // actions dropdown
    document.querySelectorAll('a[data-attendance-action]').forEach((link) => {
      link.addEventListener('click', this.onActionButtonClick.bind(this), false);
    });
  }

  handleObservationEvents() {
    // on modal save observation
    document.querySelector('.btn[data-modal-save]').addEventListener('click', this.onModalSaveObservation.bind(this));
    $('.modal.observation-modal').bind('keydown', keyTracker('crtl+enter', this.onModalSaveObservation.bind(this)));
    $('.observation-modal').on('hidden.bs.modal', () => { document.getElementById('text-observation').removeAttribute('data-text-observation') })
    $('.observation-modal').on('shown.bs.modal', () => { document.getElementById('text-observation').focus() });
  }

  handleTableEvents() {
    // toggle all checkboxes
    document.getElementById('toggle-all').addEventListener('click', (ev) => {
      const checkbox = ev.currentTarget;
      document.querySelectorAll('.attendance-card input[type="checkbox"]').forEach((el) => { el.checked = checkbox.checked });
      this.updateActionLinks();
    });

    this.handleTableRowEvents();
  }

  handleTableRowEvents() {
    document.querySelectorAll('.attendance-card input[type="checkbox"]').forEach((checkbox) => { checkbox.addEventListener('click', this.updateActionLinks.bind(this)) });

    // on change select presence
    document.querySelectorAll('.attendance-card .presences').forEach((select) => {
      select.addEventListener('change', this.onChangePresence.bind(this, select));
    });
  }

  saveSelectedSchedule() {
    let attributes = [...document.querySelectorAll('.schedule-board-modal .card.selected-schedule, .schedule-board-modal .card.selected-batch-schedule')].map(($el) => {
      return [...$el.querySelectorAll('.object-values')];
    }).flat().map((node) => node.outerHTML).join('');
    let attributeName = attributes.match(/(appointment\[attendances_attributes\]\[.*?\]\[.*?\])/)[0];

    attributes += `
      <input type="hidden" name="${attributeName}[enrollment_id]" value="${this.attendanceCard.dataset.enrollmentId}">
      <input type="hidden" name="${attributeName}[enrollment_contract_id]" value="${this.attendanceCard.dataset.enrollmentContractId}">
    `;

    this.attendanceCard.querySelector('.rescheduling-attendances').innerHTML = attributes;
    AjaxLoader.show();
    this.form.submit();
    $(this.scheduleBoardModal).modal('hide');
  }

  onActionButtonClick(ev) {
    ev.preventDefault();
    const link = ev.currentTarget;

    if (link.classList.contains('disabled'))
      return;

    this.attendanceAction(link.dataset.attendanceAction);
    this.reflectActionLabel(link);
  }

  // Mostra a ação escolhida no botão do dropdown (em vez de manter "Ações"),
  // preservando o ícone de chevron.
  reflectActionLabel(link) {
    const dropdown = link.closest('.dropdown');
    const toggle = dropdown && dropdown.querySelector('.toggle-actions');
    if (!toggle) return;

    const chevron = toggle.querySelector('svg');
    toggle.textContent = `${link.textContent.trim()} `;
    if (chevron) toggle.appendChild(chevron);
  }

  onChangePresence(select) {
    const card = select.closest('.attendance-card');
    const rescheduled = card.dataset.rescheduled === 'true';

    if (select.value == 'true' && !!rescheduled) {
      this.rescheduling.askToRemoveRescheduling(select);
    }
  }

  onReschedulingClick(ev) {
    ev.preventDefault();
    this.attendanceCard = ev.currentTarget.closest('.attendance-card');
    this.rescheduling.edit(this.attendanceCard.dataset.enrollmentId, this.attendanceCard.dataset.serviceId, ev.currentTarget.dataset.src);
  }

  openObservationModal(ev) {
    ev.preventDefault();

    const link = ev.currentTarget;
    this.attendanceCard = link.closest('.attendance-card');

    try {
      const idHiddenObservation = link.dataset.textObservation;
      const textareaObservation = document.getElementById('text-observation');
      textareaObservation.value = document.getElementById(idHiddenObservation).value;
      textareaObservation.setAttribute('data-text-observation', idHiddenObservation);
      $('.modal.observation-modal').modal('show');
    } catch(ex) {
      console.error('error: ', ex)
    }
  }

  onModalSaveObservation(ev) {
    if (!!ev)
      ev.preventDefault();

    const textareaObservation = document.getElementById('text-observation');

    this.attendanceCard.querySelector(`#${textareaObservation.dataset.textObservation}`).value = textareaObservation.value;
    this.attendanceCard.querySelector('.observation-wrapper').classList.toggle('d-none', !textareaObservation.dataset.textObservation);
    this.attendanceCard.querySelector(`#text-${textareaObservation.dataset.textObservation}`).innerHTML = isEmpty(textareaObservation.value) ? '<span class="text-muted">Nenhum observação.</span>' : textareaObservation.value;

    $('.modal.observation-modal').modal('hide');
  }

  attendanceAction(action) {
    const valueSelected = action === 'presence' ? 'true' : 'false';

    document.querySelectorAll('.attendance-card input:checked').forEach((input) => {
      const select = input.closest('.attendance-card').querySelector('.presences');
      select.setAttribute('value', valueSelected);
      this.onChangePresence(select);
    })
  }

  updateActionLinks() {
    const zeroAttendanceSelected = document.querySelectorAll('.attendance-card input:checked').length ==  0;
    document.getElementById('toggle-all').checked = document.querySelectorAll('.attendance-card input[type="checkbox"]:not(:checked)').length == 0;
    document.querySelectorAll('.toggle-actions').forEach(($el) => $el.classList.toggle('disabled', zeroAttendanceSelected));
  }
}